import * as consts from 'redux/constants';

const initialState = {
  beneficiaryTokenizationPage: {
    data: {},
    loading: false,
    error: ''
  },
  payoutMethodTypesList: {
    data: [],
    loading: false,
    error: ''
  },
  payoutRequiredFields: {
    data: [],
    loading: false,
    error: ''
  },
  allDataFetched: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case consts.SET_ALL_BENEFICIARY_DATA_FETCHED:
      return {
        ...state,
        allDataFetched: action.payload
      };
    case consts.GET_BENEFICIARY_TOKENIZATION_PAGE_START:
      return {
        ...state,
        beneficiaryTokenizationPage: {
          ...state.beneficiaryTokenizationPage,
          loading: true
        }
      };
    case consts.GET_BENEFICIARY_TOKENIZATION_PAGE_SUCCESS:
      return {
        ...state,
        beneficiaryTokenizationPage: {
          ...state.beneficiaryTokenizationPage,
          loading: false,
          data: action.payload.data,
          error: ''
        }
      };
    case consts.GET_BENEFICIARY_TOKENIZATION_PAGE_FAIL:
      return {
        ...state,
        beneficiaryTokenizationPage: {
          ...state.beneficiaryTokenizationPage,
          loading: false,
          error: action.payload.error
        }
      };
    case consts.UPDATE_BENEFICIARY_TOKENIZATION_PAGE_STATUS:
      return {
        ...state,
        beneficiaryTokenizationPage: {
          ...state.beneficiaryTokenizationPage,
          data: {
            ...state.beneficiaryTokenizationPage.data,
            status: action.payload.status
          }
        }
      };
    case consts.GET_PAYOUT_METHOD_TYPES_START:
      return {
        ...state,
        payoutMethodTypesList: {
          ...state.payoutMethodTypesList,
          loading: true
        }
      };
    case consts.RESET_PAYOUT_METHOD_TYPES:
      return {
        ...state,
        payoutMethodTypesList: {
          ...state.payoutMethodTypesList,
          loading: false,
          data: [],
          error: ''
        }
      };
    case consts.GET_PAYOUT_METHOD_TYPES_SUCCESS:
      return {
        ...state,
        payoutMethodTypesList: {
          ...state.payoutMethodTypesList,
          loading: false,
          data: action.payload.data,
          error: ''
        }
      };
    case consts.GET_PAYOUT_METHOD_TYPES_FAIL:
      return {
        ...state,
        payoutMethodTypesList: {
          ...state.payoutMethodTypesList,
          loading: false,
          error: action.payload.error
        }
      };
    case consts.GET_PAYOUT_REQUIRED_FIELDS_START:
      return {
        ...state,
        payoutRequiredFields: {
          ...state.payoutRequiredFields,
          loading: true
        }
      };
    case consts.RESET_PAYOUT_REQUIRED_FIELDS:
      return {
        ...state,
        payoutRequiredFields: {
          ...state.payoutRequiredFields,
          loading: false,
          data: [],
          error: ''
        }
      };
    case consts.GET_PAYOUT_REQUIRED_FIELDS_SUCCESS:
      return {
        ...state,
        payoutRequiredFields: {
          ...state.payoutRequiredFields,
          loading: false,
          data: action.payload.data,
          error: ''
        }
      };
    case consts.GET_PAYOUT_REQUIRED_FIELDS_FAIL:
      return {
        ...state,
        payoutRequiredFields: {
          ...state.payoutRequiredFields,
          loading: false,
          error: action.payload.error
        }
      };
    case consts.UPDATE_PAYOUT_REQUIRED_FIELDS:
      return {
        ...state,
        payoutRequiredFields: {
          ...state.payoutRequiredFields,
          data: action.payload.data
        }
      };
    default:
      return state;
  }
};

export default reducer;
